import React, { useRef } from "react"
import parentStyles from "../styles.css"
import styles from "./styles.css"
import PropTypes from "prop-types"

const SelectBoxLabel = ({
  hasTitle,
  options,
  values,
  formik,
  customerSelected,
  tab
}) => {
  const refFieldSet = useRef(null)
  const refLeg = useRef(null)
  const { touched, errors, setFieldValue, setErrors, handleBlur } = formik
  const { name, placeholder, isDisabled } = values

  const isErrorField = touched[name] && errors[name]

  const handleFocus = () => {
    if (refFieldSet.current) {
      refLeg.current.style.color = "#28BEA5"
      refFieldSet.current.style.border = "1px solid #28BEA5"
    }
  }

  const handleChange = (event) => {
    const { name, value } = event.target

    setFieldValue(name, value, true)

    const updatedErrors = { ...errors }
    if (updatedErrors[name]) {
      delete updatedErrors[name]
      setErrors(updatedErrors)
    }
  }

  const renderSelect = (name, options) => {
    return (
      <select
        name={name}
        onChange={(e) => handleChange(e)}
        onBlur={handleBlur}
        onFocus={handleFocus}
        disabled={isDisabled}
        className={`${styles.icon_arrow}
         ${hasTitle ? styles.option_style : styles.select}
         ${isErrorField && parentStyles.focus_error}`}
        tabIndex={tab}
      >
        {formik.values[name] ? (
          <option value={formik.values[name]}>{formik.values[name]}</option>
        ) : (
          <option value={formik.values[name]}>{placeholder}</option>
        )}

        {options &&
          options.map((object, i) => (
            <option key={i} value={`${object}`}>
              {object}
            </option>
          ))}
      </select>
    )
  }

  return (
    <div>
      <div className={parentStyles.line}>
        {hasTitle ? (
          <fieldset ref={refFieldSet} className={`${styles.select_container}`}>
            <legend ref={refLeg} className={styles.legend_select}>
              Tipo de atendimento
            </legend>
            {renderSelect(name, options)}
          </fieldset>
        ) : (
          <div>
            {renderSelect(name, options)}
            {isErrorField && (
              <div className={parentStyles.error}>{errors[name]}</div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

SelectBoxLabel.propTypes = {
  hasTitle: PropTypes.bool,
  options: PropTypes.array,
  values: PropTypes.object,
  formik: PropTypes.object,
  customerSelected: PropTypes.object,
  tab: PropTypes.number
}

export default SelectBoxLabel



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/SelectBoxLabel/index.js